import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import styled from 'styled-components/macro';
import { TabBar, TabItem } from '@deeptrue-frontend/ui';
import RouterProvider from 'components/RouterProvider/RouterProvider';
import { compose, findIndex } from 'ramda';
import { useFormatMessage } from 'components/IntlProvider';
import StoreProvider from 'components/StoreProvider/StoreProvider';

const StyledTabItem = styled(TabItem)``;

const { withRouter, ROUTES } = RouterProvider;
const { connect, selectors } = StoreProvider;

const urls = [
  ROUTES.SETTINGS.PROFILE,
  ROUTES.SETTINGS.EMAIL,
  ROUTES.SETTINGS.PASSWORD,
  ROUTES.SETTINGS.ORGANIZATION,
];

const bexioUrls = [...urls, ROUTES.SETTINGS.BEXIO];

const checkPathname = (pathname: string) => {
  const itemIndex = findIndex((url: string) => new RegExp(url).test(pathname))(
    urls
  );

  return itemIndex || 0;
};

interface SettingsMenuProps extends RouteComponentProps {
  isBexioUser: boolean;
}

const SettingsMenu = ({
  history,
  location,
  isBexioUser,
}: SettingsMenuProps) => {
  const t = useFormatMessage();
  return (
    <TabBar
      selectedIndex={checkPathname(location.pathname)}
      onSelect={(value: number) =>
        history.push(isBexioUser ? bexioUrls[value] : urls[value])
      }
    >
      <StyledTabItem title={t('settings.menu.profile', 'Profile')} />
      <StyledTabItem title={t('settings.menu.email', 'Email')} />
      <StyledTabItem title={t('settings.menu.password', 'Password')} />
      <StyledTabItem title={t('settings.menu.organization', 'Organization')} />
      {isBexioUser && (
        <StyledTabItem title={t('settings.menu.bexio', 'Bexio')} />
      )}
    </TabBar>
  );
};

export default compose(
  withRouter,
  connect((state) => ({
    isBexioUser: selectors.authSelectors.isBexioUser(state),
  }))
)(SettingsMenu);
